import React, { Component, useState } from "react";
import { Link } from "react-router-dom";
import { useLoginState, useUserPremiumState } from "lib/hooks/userHooks";
import { amplitudeLog } from "lib/general-helper";

const ComboModal = (props) => {
  const isLoggedIn = useLoginState();
  const { isPremium } = useUserPremiumState();

  const upgradeLink = () => {
    if (isLoggedIn && !isPremium) {
      return `/boost/payment?planType=1-months`;
    } else {
      return `/signup?continue=/purchase/1-months&type=premium_boost`;
    }
  };

  return (
    <div className="combo-blur-wrapper">
      <div className="blur-container">
        <img className="lock-img" src="https://static.bigbrain.gg/assets/lol/combos/imgs/combo-locked-icon.png" alt="locked" />
        <div className="desc">Oof! This combo is only available to BOOST users.</div>
        <Link to={upgradeLink()} className="btn-light-blue" onClick={amplitudeLog("combo-modal")}>
          Upgrade Now
        </Link>
      </div>
    </div>
  );
};

export default ComboModal;
